// extracted by mini-css-extract-plugin
export default {"form-actions":"RegisterLimitFormActions_form-actions__GFYZ9","form-actions__back-button":"RegisterLimitFormActions_form-actions__back-button__eE-kZ"};